module.exports = __webpack_public_path__ + "static/media/slakteweb-logo@2x.4f074b70.png";